import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { tienePermisoEnSesion } from "@/shared/auth/permiso-en-sesion";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { AdminPermisosPage } from "@/features/admin-permisos/components/AdminPermisosPage";
import { catalogoPermisosQueryOptions } from "@/features/admin-permisos/hooks/use-permisos-admin";

/** Ruta `/admin/permisos` · gestor del catálogo de permisos (RBAC · P46). */
export const Route = createFileRoute("/_authed-tw/admin/permisos")({
  loader: ({ context: { queryClient } }) =>
    tienePermisoEnSesion([PERMISOS.adminPermisos])
      ? queryClient.ensureQueryData(catalogoPermisosQueryOptions)
      : undefined,
  component: () => (
    <PermissionGate permisos={[PERMISOS.adminPermisos]}>
      <AdminPermisosPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
